import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_get_shippingcontents_by_orderIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { orderId: number }): 
  Promise<{ result: { ShipmentLineId?: number, LicensePlateId?: number, LotId?: number, PackagedId?: number, PackagedAmount?: number, LicensePlate?: { Id?: number, Archived?: boolean, GrossVolume?: number, GrossWeight?: number, LookupCode?: string, NetVolume?: number, NetWeight?: number, ShipmentId?: number, VolumeUomId?: number, WeightUomId?: number, SerialNumbers?: { Id?: number, Archived?: boolean, GrossVolume?: number, GrossWeight?: number, LicensePlateId?: number, LookupCode?: string, LotId?: number, NetVolume?: number, NetWeight?: number, PackagingId?: number, VolumeUomId?: number, WeightUomId?: number, TasksForSerialNumber?: { Id?: number, ShipmentId?: number }[] }[] }, Lot?: { Id?: number, LastReceiveDate?: string, LookupCode?: string, ReceiveDate?: string, VendorLot?: { Id?: number, ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string }, Material?: { Id?: number, Description?: string, LookupCode?: string, Name?: string, PackagingLookups?: { PackagingId?: number, QuantityPrecisionScale?: number, ShippingVolume?: number, ShippingWeight?: number, Volume?: number, VolumeUomId?: number, Weight?: number, WeightUomId?: number }[] } }, Packaged?: { Name?: string, ShortName?: string }, ShipmentLine?: { Id?: number, OrderId?: number } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.orderId)) {
      $missingRequiredInParams.push('\'orderId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { orderId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { ShipmentLineId?: number, LicensePlateId?: number, LotId?: number, PackagedId?: number, PackagedAmount?: number, LicensePlate?: { Id?: number, Archived?: boolean, GrossVolume?: number, GrossWeight?: number, LookupCode?: string, NetVolume?: number, NetWeight?: number, ShipmentId?: number, VolumeUomId?: number, WeightUomId?: number, SerialNumbers?: { Id?: number, Archived?: boolean, GrossVolume?: number, GrossWeight?: number, LicensePlateId?: number, LookupCode?: string, LotId?: number, NetVolume?: number, NetWeight?: number, PackagingId?: number, VolumeUomId?: number, WeightUomId?: number, TasksForSerialNumber?: { Id?: number, ShipmentId?: number }[] }[] }, Lot?: { Id?: number, LastReceiveDate?: string, LookupCode?: string, ReceiveDate?: string, VendorLot?: { Id?: number, ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string }, Material?: { Id?: number, Description?: string, LookupCode?: string, Name?: string, PackagingLookups?: { PackagingId?: number, QuantityPrecisionScale?: number, ShippingVolume?: number, ShippingWeight?: number, Volume?: number, VolumeUomId?: number, Weight?: number, WeightUomId?: number }[] } }, Packaged?: { Name?: string, ShortName?: string }, ShipmentLine?: { Id?: number, OrderId?: number } }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.orderId)) {
      $missingRequiredInParams.push('\'orderId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { orderId: number, $keys: { ShipmentLineId?: number, LicensePlateId?: number, LotId?: number, PackagedId?: number }[] }): 
  Promise<{ result: { ShipmentLineId?: number, LicensePlateId?: number, LotId?: number, PackagedId?: number, PackagedAmount?: number, LicensePlate?: { Id?: number, Archived?: boolean, GrossVolume?: number, GrossWeight?: number, LookupCode?: string, NetVolume?: number, NetWeight?: number, ShipmentId?: number, VolumeUomId?: number, WeightUomId?: number, SerialNumbers?: { Id?: number, Archived?: boolean, GrossVolume?: number, GrossWeight?: number, LicensePlateId?: number, LookupCode?: string, LotId?: number, NetVolume?: number, NetWeight?: number, PackagingId?: number, VolumeUomId?: number, WeightUomId?: number, TasksForSerialNumber?: { Id?: number, ShipmentId?: number }[] }[] }, Lot?: { Id?: number, LastReceiveDate?: string, LookupCode?: string, ReceiveDate?: string, VendorLot?: { Id?: number, ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string }, Material?: { Id?: number, Description?: string, LookupCode?: string, Name?: string, PackagingLookups?: { PackagingId?: number, QuantityPrecisionScale?: number, ShippingVolume?: number, ShippingWeight?: number, Volume?: number, VolumeUomId?: number, Weight?: number, WeightUomId?: number }[] } }, Packaged?: { Name?: string, ShortName?: string }, ShipmentLine?: { Id?: number, OrderId?: number } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.orderId)) {
      $missingRequiredInParams.push('\'orderId\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      orderId: number    }) {
        if(isNil($inParams.orderId)) {
          return true; 
        }
      return false;
    }
}
